module.exports = __webpack_public_path__ + "static/media/fazhan4.66c46135.png";